import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../i18n';
export function CookiePolicyPage() {
  const {
    t
  } = useTranslation();
  return <Layout data-id="element-1337">
      <section className="bg-teal-900 text-white py-16" data-id="element-1338">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1339">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1340">Cookie Policy</h1>
          <p className="text-teal-100" data-id="element-1341">Last updated: 5 February 2026</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50" data-id="element-1342">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1343">
          <Card className="p-8 md:p-12 prose prose-teal max-w-none" data-id="element-1344">
            <p className="lead" data-id="element-1345">
              This Cookie Policy explains how Dentico Dental Clinic Ltd uses
              cookies and similar technologies on denticoclinic.co.uk.
            </p>

            <h3 data-id="element-1346">We use:</h3>
            <ul className="space-y-2" data-id="element-1347">
              <li data-id="element-1348">
                <strong data-id="element-1349">Strictly necessary cookies</strong> — required for core
                site functionality.
              </li>
              <li data-id="element-1350">
                <strong data-id="element-1351">Analytics cookies</strong> — to understand website
                performance and improve user experience (used with consent where
                required).
              </li>
              <li data-id="element-1352">
                <strong data-id="element-1353">Functional cookies</strong> — to remember preferences
                such as language/settings.
              </li>
              <li data-id="element-1354">
                <strong data-id="element-1355">Marketing cookies</strong> (if enabled) — to measure
                campaign performance.
              </li>
            </ul>

            <h3 data-id="element-1356">Managing Cookies</h3>
            <p data-id="element-1357">
              You can manage cookie preferences in our cookie banner/settings
              and in your browser.
            </p>
            <p data-id="element-1358">
              Some third-party services (e.g. analytics/maps/booking tools) may
              set cookies under their own policies.
            </p>

            <div className="border-t border-gray-200 pt-8 mt-8" data-id="element-1359">
              <p data-id="element-1360">
                Contact:{' '}
                <a href="mailto:info@denticoclinic.co.uk" className="text-teal-600 font-medium hover:underline" data-id="element-1361">
                  info@denticoclinic.co.uk
                </a>
              </p>
            </div>
          </Card>
        </div>
      </section>
    </Layout>;
}